import { useDependencies } from '@servicetitan/react-ioc';
import {
    PortalMode,
    PortalSettings,
    PortalStore,
    portalStoreToken,
    PortalUser,
} from '../stores/portal.store';

export const usePortalStore = (): PortalStore => {
    const [store] = useDependencies(portalStoreToken);

    return store;
};

export const usePortalMode = (): PortalMode => {
    const [{ mode }] = useDependencies(portalStoreToken);

    return mode;
};

export const usePortalSettings = (): PortalSettings | undefined => {
    const [{ settings }] = useDependencies(portalStoreToken);

    return settings;
};

export const usePortalUser = (): PortalUser | undefined => {
    const [{ user }] = useDependencies(portalStoreToken);

    return user;
};
